import { Anchor, Flex, Text, csx } from '@vtex/admin-ui'
import React from 'react'

import { useAdmin } from '@vtex/raccoon-next'
import type { ColumnParams, GenericPromotion } from 'typings'
import { TextEllipsisStyle } from './NameAndDescription'

export function Name({ item }: ColumnParams<GenericPromotion>) {
  const { account } = useAdmin()

  return (
    <Anchor
      href={`https://${account}.myvtex.com/admin/promotions/archived/${item.id}`}
      onClick={(e: React.MouseEvent) => e.preventDefault()}
      className={csx({
        ':hover': { textDecoration: 'none' },
        width: 'full',
        height: 'full',
      })}
    >
      <Flex align="center" className={csx({ height: 'full' })}>
        <Text variant="action1" className={csx(TextEllipsisStyle)}>
          {item.name}
        </Text>
      </Flex>
    </Anchor>
  )
}
